import React from 'react';
import ParentChildCard from './ParentChildCard';


/** Handles recursive rendering of tree nodes and their children
 * @param {node : object} data/node to render 
 * @param {updateNode : function} update the child after fetching the child nodes
 * @param {path : array} holds the path of a each node
 */
const ParentChildTree = ({ node, updateNode, path = [], breadcrumbData = [] }) => {
    const currentPath = [...path];
    const currentBreadcrumb = breadcrumbData.length === 0
        ? [node.qrCode]
        : [...breadcrumbData, node.qrCode];

    return (
        <li className={node && node.isExpand ? "imidiate-child" : ""}>
            <ParentChildCard
                updateNode={updateNode}
                node={node}
                path={currentPath}
                breadcrumbData={currentBreadcrumb}
            />
            {node.children && node.children.length > 0 && (
                <ul>
                    {node.children.map((child, index) => (
                        <ParentChildTree
                            key={child.qrCode}
                            node={child}
                            updateNode={updateNode}
                            path={[...currentPath, index]}
                            breadcrumbData={currentBreadcrumb}
                        />
                    ))}
                </ul>
            )}
        </li>
    );
};

export default ParentChildTree;